<template>
  <v-row wrap v-if="tenant" class="pa-5">
    <v-col cols="12" v-if="current_user.is_super_admin === 1">
      <m-breadcrum :items="bread"></m-breadcrum>
    </v-col>
    <v-col cols="12">
      <m-card
        title="Detail Tenant"
        class="pa-5"
        :setting="current_user.is_super_admin === 1"
        :edit="current_user.is_admin == 1"
        @edit="edit"
        @setting="settingDefault"
      >
        <v-row wrap>
          <v-col cols="12" sm="6" md="6" lg="5" xl="5" class="mt-5">
            <v-card text color="#009688" flat>
              <v-img class="white--text" height="300px" src="img/parallax.png">
                <v-container fill-height container--fluid>
                  <v-row fill-height>
                    <v-col class="text-center" cols="12" align-end flexbox>
                      <v-avatar :size="150" color="grey lighten-4">
                        <!-- <v-img
                          sizes="50"
                          :src="tenant.file_foto || 'img/tenant-default.png'"
                          alt="avatar"
                        />-->
                        <img
                          :src="tenant.file_foto || 'img/tenant-default.png'"
                          alt="avatar"
                        />
                      </v-avatar>
                      <div
                        class="card-footer text-muted"
                        v-html="message"
                      ></div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-img>
              <v-btn
                icon
                large
                color="white"
                style="position: absolute;right: 0px;top: 5px;"
                id="pick-avatar"
              >
                <v-icon>mdi-camera</v-icon>
              </v-btn>
              <avatar-cropper
                :upload-handler="cropperHandler"
                trigger="#pick-avatar"
                :output-mime="cropperOutputMime"
                :output-quality="0.8"
                :output-options="{ width: 400, height: 400 }"
                :labels="{ submit: 'Simpan', cancel: 'Hapus' }"
              />
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="7" xl="6">
            <v-list>
              <v-subheader class="title primary--text"
                >Identitas Tenant</v-subheader
              >
              <v-divider></v-divider>
              <m-list-tile-info label="Tenant ID" :value="tenant.no_reg" />
              <m-list-tile-info label="Nama" :value="tenant.nama" />
              <m-list-tile-info label="Surel" :value="tenant.email" />
              <m-list-tile-info label="Alamat" :value="tenant.alamat" />
            </v-list>
            <v-list v-if="current_user.is_super_admin === 1">
              <v-toolbar flat>
                <v-toolbar-title class="px-0">
                  <v-subheader class="title primary--text px-0">
                    Informasi Kuota</v-subheader
                  >
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-divider></v-divider>
              <m-list-tile-info
                label="Tanggal Mulai"
                :value="tenant.kuota && tenant.kuota.start_at | toSD"
              />
              <m-list-tile-info
                label="Tanggal Selesai"
                :value="tenant.kuota && tenant.kuota.expired_at | toSD"
              />
              <m-list-tile-info
                label="Total Kuota"
                :value="(tenant.kuota && tenant.kuota.kuota) || 0"
              />
            </v-list>
          </v-col>
        </v-row>
      </m-card>
    </v-col>
    <v-col v-if="current_user.is_super_admin" cols="12">
      <v-row wrap>
        <v-col cols="12" sm="12" md="12">
          <m-card-list
            two-line
            title="Daftar Organisasi"
            :headers="headers"
            :items="items"
            footer
            add
            search
            :page="page"
            @search="
              search => {
                keyword = search;
                loadOrganisasi();
              }
            "
            @change:page="
              pg => {
                cp = pg;
                loadOrganisasi();
              }
            "
            @add="onAdd"
          >
            <template v-slot:items="{ props, item }">
              <tr v-if="$vuetify.breakpoint.smAndUp">
                <td>
                  <a @click="detail(item)">
                    <v-avatar :size="30" color="grey lighten-4 mr-3">
                      <img
                        :src="item.file_foto || 'img/organisasi-default.png'"
                        alt="avatar"
                      />
                    </v-avatar>
                    {{ pVal(item, "nama") }}
                  </a>
                </td>
                <td>{{ pVal(item, "no_telp") }}</td>
                <td>{{ pVal(item, "email") }}</td>
                <td>
                  <v-chip v-if="isSimpatika" small class="mx-2" dark :color="item.is_langganan ? 'orange' : 'dark'" style="width: 100px">
                    <v-icon v-if="item.is_langganan" left>mdi-crown</v-icon>
                    <span :class="item.is_langganan ? '' : 'ml-5'"> {{ item.is_langganan ? 'Berbayar' : 'Gratis' }}</span>
                  </v-chip>
                  <span v-else>{{ pVal(item, "fax") }}</span>
                </td>
                <td>
                  <m-menu
                    left
                    style="float:right"
                    :items="more_menu"
                    :object="item"
                  />
                </td>
              </tr>
              <tr v-else>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mr-2">
                    {{ headers[0].text }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "nama") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mr-2">
                    {{ headers[1].text }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "no_telp") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mr-2">
                    {{ headers[2].text }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "email") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mr-2">
                    {{ headers[3].text }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    <v-chip v-if="isSimpatika" small class="mx-2" dark :color="item.is_langganan ? 'orange' : 'dark'" style="width: 100px">
                      <v-icon v-if="item.is_langganan" left>mdi-crown</v-icon>
                      <span> {{ item.is_langganan ? 'Berbayar' : 'Gratis' }}</span>
                    </v-chip>
                    <span v-else>{{ pVal(item, "fax") }}</span>
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mr-2">Aksi</div>
                  <div class="v-data-table__mobile-row__cell">
                    <m-menu
                      left
                      style="float:right"
                      :items="more_menu"
                      :object="item"
                    />
                  </div>
                </td>
              </tr>
            </template>
          </m-card-list>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="current_user.is_admin" cols="12">
      <m-card
        title="Tenant Terhubung"
        class="pa-5"
      >
        <m-card-list
          two-line
          :items="items"
          footer
          add
          search
          :page="page"
          @add="onAddConnection"
          @search="
              search => {
                keyword = search;
                loadKoneksi();
              }
            "
          @change:page="
              pg => {
                cp = pg;
                loadKoneksi();
              }
            "
        >
          <template v-slot:items="{ props, item }">
            <tr>
              <td style="width: 40%">
                <v-list-item>
                  <v-list-item-avatar>
                    <v-avatar :size="40" color="grey lighten-4">
                      <img :src="item.file_foto || 'img/organisasi-default.png'" alt="avatar" />
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <div> {{ pVal(item, 'nama') }}</div>
                    <div class="caption grey--text">{{ pVal(item, 'email') }}</div>
                  </v-list-item-content>
                </v-list-item>
              </td>
              <td>
                <div class="grey--text caption"> Tenant ID</div>
                <div class="mt-n1 primary--text body-1"> {{ pVal(item, 'no_reg') }} </div>
              </td>
              <td>
                <template v-if="Number(getDeepObj(item, 'is_connected')) === 1">
                  <v-btn depressed outlined color="primary" @click="onCancelConnect(item)"><v-icon left>mdi-link-off</v-icon> Terhubung</v-btn>
                </template>
              </td>
            </tr>
          </template>
        </m-card-list>
      </m-card>
    </v-col>
    <component
      :is="
        current_user.is_super_admin === 1 ? 'SettingAdmin' : 'SettingOrganisasi'
      "
      ref="dlgOrgs"
      :tenant="tenant || {}"
    />
    <SettingDefault ref="dlgSetting" />
    <SettingKuota ref="dlgKuota" />
    <DetailOrganisasi ref="dlgDetail" />
    <ChangeDlg ref="dlg" />
    <TenantConnect ref="dlgTenant" @reload="loadKoneksi"/>
  </v-row>
</template>
<script>
import AvatarCropper from "vue-avatar-cropper";
import ChangeDlg from "../components/Form.vue";
import SettingDefault from "@/modules/organisasi/components/FormSetting";
import SettingOrganisasi from "@/modules/organisasi/components/Form";
import SettingAdmin from "@/modules/organisasi/components/FormAdmin";
import SettingKuota from "../components/FormKuota";
import DetailOrganisasi from "@/modules/tenant/components/DetailOrganisasi";
import TenantConnect from "@/modules/tenant/components/TenantConnect.vue";
export default {
  components: {
    AvatarCropper,
    ChangeDlg,
    SettingDefault,
    SettingAdmin,
    SettingOrganisasi,
    SettingKuota,
    DetailOrganisasi,
    TenantConnect
  },
  data() {
    return {
      message: "",
      logo: null,
      tenant: null,
      cropperOutputMime: null,
      cp: 1,
      page: {},
      keyword: "",
      items: [],
      itemsConnected: [],
      more_menu: [
        {
          title: "Detail",
          click: (i, o) => this.detail(o),
          check: () => true
        },
        {
          title: "Ubah",
          click: (i, o) => this.editOrg(o),
          check: () => true
        }
      ]
    };
  },
  computed: {
    headers() {
      return [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Tlpn", align: "left", value: "no_telp" },
        { text: "Surel", align: "left", value: "email" },
        { text: this.isSimpatika ? "Versi" : "Fax", align: "left", value: this.isSimpatika ? "versi" : 'fax' },
        { text: "", align: "center", sortable: false }
      ]
    },

    bread() {
      return [
        {
          icon: "mdi-bank",
          title: "Tenant",
          to: {
            name: "tenant"
          }
        },
        {
          icon: "mdi-information",
          title: this.tenant.nama || ""
        }
      ];
    },

    isSimpatika() {
      return ['TEN-LXANG', 'TEN-YTPQU'].includes(this.$route.params.no_reg)
    }
  },
  activated() {
    this.load();
    if (this.current_user.is_admin) {
      this.loadKoneksi();
    }
  },
  methods: {
    load() {
      this.$store
        .dispatch(
          "tenant/detail",
          this.current_user.is_super_admin
            ? this.$route.params.no_reg
            : this.current_user.kode_tenant
        )
        .then(res => {
          this.tenant = res.data;
          if (res.data.file_foto)
            this.tenant.file_foto = res.data.file_foto + "?" + Math.random();
        })
        .then(() => {
          if (this.current_user.is_super_admin) this.loadOrganisasi();
        })
        .catch(e => e);
    },
    loadKoneksi() {
      this.$store.dispatch(
        'tenant/getKoneksi',
        { no_reg: this.current_user.kode_tenant, params: {} }
      ).then((resp) => {
        this.page = resp.data || {}
        this.items = resp.data.data || []
      })
    },
    loadOrganisasi() {
      this.$store
        .dispatch("organisasi/get", {
          page: this.cp,
          keyword: this.keyword,
          kode_tenant: this.$route.params.no_reg
        })
        .then(({ data }) => {
          this.page = data;
          this.items = data.data;
        })
        .then(() => {
          this.items.map(item => {
            this.checkImage(item.file_foto, "img/organisasi-default.png").then(
              res => {
                item.file_foto = res;
              }
            );
            return item;
          });
        })
        .catch(e => e);
    },
    cropperHandler(cropper) {
      var imgdat = cropper.getCroppedCanvas().toDataURL(this.cropperOutputMime);
      var file = this.dataURLtoFile(imgdat, "test.png");

      this.$store
        .dispatch("tenant/uploadImage", {
          kode_tenant: this.tenant.no_reg,
          data: file
        })
        .then(() => {
          this.load();
        })
        .catch(e => e);
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    detail(obj) {
      this.$router.push({
        name: "tenant.anggota",
        params: {
          no_reg: obj.kode_tenant,
          kode_organisasi: obj.kode_organisasi
        }
      });
      // this.$refs.dlgDetail.open(obj)
    },
    // eslint-disable-next-line
    edit() {
      this.$refs.dlg.open(this.tenant).then(() => {
        this.load();
      });
    },
    settingDefault() {
      if (this.current_user.is_super_admin === 1) {
        this.setKuota()
      }else {
        this.$refs.dlgSetting.open(this.tenant_id).then(() => {
          this.load();
        });
      }
    },
    setKuota(obj) {
      let data = {};
      if (obj) {
        data = Object.assign({}, obj, { tenant_id: this.tenant.tenant_id });
      }

      this.$refs.dlgKuota
        .open(obj && obj.organisasi_id ? data : this.tenant)
        .then(() => {
          if (obj) this.loadOrganisasi();
          this.load();
        });
    },
    close() {
      this.$router.push({
        name: "tenant"
      });
    },
    onAdd() {
      this.$refs.dlgOrgs
        .open({
          kode_tenant: this.$route.params.no_reg
        })
        .then(() => {
          this.loadOrganisasi();
        });
    },
    onAddConnection() {
      this.$refs.dlgTenant.open()
    },
    editOrg(obj) {
      this.$refs.dlgOrgs.open(obj).then(() => {
        this.loadOrganisasi();
      });
    },
    onCancelConnect(item) {
      this.$confirmDanger(
        `Apakah Anda ingin <b>Melepas Hubungan</b> dengan Tenant ini ?`,
        { color: 'red' },
        'Batalkan Koneksi'
      ).then(() => {
        this.$store
          .dispatch('tenant/setKoneksi', {
            no_reg: this.current_user.kode_tenant,
            api: 'putus-koneksi',
            params: { tenant_id: item.tenant_id },
          })
          .then(() => {
            this.$success('Koneksi Berhasil Dibatalkan')
            this.loadKoneksi()
          })
      })
    },
    checkImage(url, fallback) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve(url);
        img.onerror = () => {
          reject(`image not found for url ${url}`);
        };
      }).catch(() => {
        return fallback;
      });
    }
  }
};
</script>
